import React from 'react'
import styled, { css } from 'styled-components'
import PublishedCell from './PublishedCell'
import Table from 'components/Table'
import Video, { ValidResourceTypes } from 'types/Resource'

type ResourceProps = {
  type: ValidResourceTypes
  resource: Video
}

type Props = {
  resource: Video
  onSuccessfulSubmission: () => void
  onClickEditResource:(val:ResourceProps)=>void
}

const WistiaVideoRow = ({ resource, onSuccessfulSubmission, onClickEditResource }: Props) => {
  if (resource == null) {
    return null
  }

  return (
    <S.TableRow key={resource.name}>
      <S.NameThumbnailCell>
        <a
          href={resource.url}
          target="_blank"
          rel="noreferrer"
        >
          <S.ThumbnailImage
            src={resource.thumbnail}
            alt={`${resource.name} help video thumbnail`}
          />
        </a>

        <S.NameCell>
          <a
            href={resource.url}
            target="_blank"
            rel="noreferrer"
          >
            {resource.name}
          </a>
        </S.NameCell>
      </S.NameThumbnailCell>

      <S.DescriptionCell>
        {resource.description}
        <br />
        <i>{resource.duration} minutes</i>
      </S.DescriptionCell>
      <S.DateCell>{resource.wistiaUpdatedAt}</S.DateCell>

      <PublishedCell type="video" resource={resource} onSuccessfulSubmission={onSuccessfulSubmission} onClickEditResource={onClickEditResource} />
    </S.TableRow>
  )
}

export default WistiaVideoRow

const cellStyle = css`
  padding: 15px;
`

const S = {
  DateCell: styled(Table.Cell)`
    ${cellStyle}
    flex: 1;
  `,
  DescriptionCell: styled(Table.Cell)`
    ${cellStyle}
    flex: 2;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex: 2;
  `,
  NameThumbnailCell: styled(Table.Cell)`
    align-items: center;
    flex: 2;
  `,
  NameCell: styled(Table.Cell)`
    ${cellStyle}
    align-items: center;
  `,
  TableRow: styled(Table.Row)`
    align-items: center;
  `,
  ThumbnailImage: styled.img`
    ${cellStyle}
    max-height: 80px;
  `
}
